export default __webpack_public_path__ + "pgnv-assets/f77312d4a1d940ca265e6966e7d4cad8.png";